import { deepPurple } from "@mui/material/colors";

import {
  BRAND_AMBER,
  BRAND_DANGER,
  BRAND_DANGER_TINT,
  BRAND_INK,
  BRAND_MAROON,
  BRAND_PINK,
  BRAND_PINK_DARK,
  BRAND_PINK_TINT,
  BRAND_SAND,
  BRAND_STONE,
  BRAND_SUCCESS,
  BRAND_SUCCESS_TINT,
  BRAND_TAUPE,
  BRAND_WARNING_TINT,
  TIME_SLOT_AM_DARK,
  TIME_SLOT_NOC_DARK,
  TIME_SLOT_PM_DARK,
} from "./colorPrimitives";

// Rebrand color constants for the legacy MUI theme.
// Brand values are sourced from the shared primitives module
// (src/appV2/lib/Theme/colorPrimitives.ts) so the legacy theme and
// the Berlin theme stay in sync. Values not shared with Berlin remain literals.

// --- Core brand colors ---
export const REBRAND_PRIMARY_COLOR = BRAND_PINK;
export const REBRAND_PRIMARY_DARK = BRAND_PINK_DARK;
export const REBRAND_SECONDARY_COLOR = BRAND_MAROON;
export const REBRAND_MUTED_COLOR = BRAND_TAUPE;
export const REBRAND_DANGER_COLOR = BRAND_DANGER;
export const REBRAND_LINK_COLOR = BRAND_MAROON;
export const REBRAND_TEXT_STRONG = BRAND_INK;
export const REBRAND_WARNING_COLOR = BRAND_AMBER;

// --- Gray equivalents ---
export const REBRAND_GRAY_00 = BRAND_INK;
export const REBRAND_GRAY_4F = BRAND_TAUPE;
export const REBRAND_GRAY_C0 = BRAND_STONE;
export const REBRAND_GRAY_E0 = BRAND_SAND;
export const REBRAND_GRAY_F0 = "#F8F4EA";
export const REBRAND_GRAY_1F = BRAND_MAROON;

// --- Shift AM/PM/NOC dark variants (for text on light backgrounds) ---
export const REBRAND_AM_DARK = TIME_SLOT_AM_DARK;
export const REBRAND_PM_DARK = TIME_SLOT_PM_DARK;
export const REBRAND_NOC_DARK = TIME_SLOT_NOC_DARK;

// --- Background colors ---
export const REBRAND_BACKGROUND_BASE = "#FFFEFC";
export const REBRAND_BACKGROUND_PAGE = "#FDF9F3";

// --- DataGrid / dark header ---
export const REBRAND_HEADER_DARK = BRAND_INK;

// --- Alert colors ---
export const REBRAND_ALERT_COLORS = {
  warning: {
    backgroundColor: BRAND_WARNING_TINT,
    color: BRAND_AMBER,
  },
  info: {
    backgroundColor: BRAND_PINK_TINT,
    color: BRAND_PINK,
  },
  error: {
    backgroundColor: BRAND_DANGER_TINT,
    color: BRAND_DANGER,
  },
  success: {
    backgroundColor: BRAND_SUCCESS_TINT,
  },
};

// --- Chip colors ---
export const REBRAND_CHIP_COLORS = {
  primary: { color: REBRAND_PRIMARY_COLOR, backgroundColor: BRAND_PINK_TINT },
  secondary: { color: REBRAND_SECONDARY_COLOR, backgroundColor: REBRAND_GRAY_E0 },
  success: { color: BRAND_SUCCESS, backgroundColor: BRAND_SUCCESS_TINT },
  error: { color: REBRAND_DANGER_COLOR, backgroundColor: BRAND_DANGER_TINT },
  warning: { color: REBRAND_WARNING_COLOR, backgroundColor: BRAND_WARNING_TINT },
  info: { color: REBRAND_PRIMARY_COLOR, backgroundColor: BRAND_PINK_TINT },
  accent: { backgroundColor: deepPurple[100], color: deepPurple[800] },
  blue600: { color: "#E8F4FF", backgroundColor: "#082A74" },
  green600: { color: "#E0FBEF", backgroundColor: "#169563" },
};

// --- Typography ---
export const REBRAND_TYPOGRAPHY_COLORS = {
  body2: {
    light: REBRAND_GRAY_4F,
    dark: REBRAND_GRAY_00,
  },
};
